// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizTitle_cont__31HHI","title":"BizTitle_title__3VdOP","desc":"BizTitle_desc__Y3RWL"};